import { rememberUnifiedViewId } from '../../helpers/unified-view-session-tracker';
import {
  removeConditionByField,
  upsertConditionByField,
} from '../../helpers/filters/canonical-filter-helpers';
import { ensureViewExists } from './ensure-view-exists';
import type { ImmerSet, ViewFilterActions } from '../../types/filter-actions-types';

export function createViewFilterActions(set: ImmerSet): ViewFilterActions {
  return {
    setFilters: (viewId, filters) => {
      set(state => {
        const view = ensureViewExists(state, viewId);
        view.filters = filters;
      });
    },

    upsertChipCondition: (viewId, field, condition) => {
      set(state => {
        const view = ensureViewExists(state, viewId);
        view.filters = upsertConditionByField(view.filters, field, condition);
      });
      rememberUnifiedViewId(viewId);
    },

    removeChipCondition: (viewId, field) => {
      set(state => {
        const view = ensureViewExists(state, viewId);
        view.filters = removeConditionByField(view.filters, field);
      });
      rememberUnifiedViewId(viewId);
    },

    clearFilters: (viewId) => {
      set(state => {
        const view = ensureViewExists(state, viewId);
        view.filters = undefined;
      });
      rememberUnifiedViewId(viewId);
    },
  };
}
